import Script from "next/script"

export default function Cookies({blok}){
    return <div className="">

    <Script
        id="CookieDeclaration"
        src="https://consent.cookiebot.com/2e6a456a-0389-4599-a0c8-5104621d573a/cd.js"
        strategy="afterInteractive"
      />
    </div>
}